export default "__VITE_ASSET__D9$jm3o___"